import { MessageActions, MessageType } from 'types/chat.types';
import { ContextMenuProps } from 'app/components/ChakraTableList/ContextMenu/types';
import { forwardRef } from 'react';
import { Message } from '../Message/Message';
import { NewMessagesIndicator } from '../NewMessagesIndicator';
import { START_INDEX } from './constants';

interface MessageRendererProps {
  virtuosoIndex: number;
  numOfItemsPrepended: number;
  messageList: MessageType[];
  contextMenuProps: ContextMenuProps;
  messageActions: MessageActions;
  userGuid?: string;
}

export const MessageRenderer = forwardRef(
  (
    {
      virtuosoIndex,
      numOfItemsPrepended,
      messageList,
      contextMenuProps,
      messageActions,
      userGuid,
    }: MessageRendererProps,
    ref
  ) => {
    const streamMessageIndex =
      virtuosoIndex + numOfItemsPrepended - START_INDEX;

    const message = messageList[streamMessageIndex];

    const isLast = streamMessageIndex === messageList.length - 1;

    if (message?.customType === 'newMessagesIndicator') {
      return <NewMessagesIndicator ref={ref} pt={2} pb={2} />;
    }

    if (!message) return <div style={{ height: '1px' }} />; // returning null or zero height breaks the virtuoso

    const handleContextMenu = (
      e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
      options
    ) => {
      contextMenuProps.setOptions(options);
      const x = e.clientX;
      const y = e.clientY;
      contextMenuProps.setPosition({ x, y });
      e.preventDefault();
    };

    const options =
      message._links?.deleteMessage || message.needRetry
        ? [
            {
              title: 'Delete',
              onClick: () => messageActions.handleDelete(message),
            },
          ]
        : [];

    return (
      <Message
        message={message}
        messageActions={messageActions}
        pt={2}
        pb={isLast ? 4 : 2}
        isCurrentUser={message.createdBy?.userGuid === userGuid}
        onContextMenu={(e: React.MouseEvent<any>) => {
          handleContextMenu(e, options);
        }}
      />
    );
  }
);
